import React from 'react'

const TagCloudItem = props => {
  const { faqs = [], handleOnClick, activeTab, setActiveTab = false } = props

  if (Array.isArray(faqs) && faqs.length === 0) return null

  if (setActiveTab) {
    return (
      <div className="TagCloudItemGroup__cardResult">
        {(Array.isArray(faqs) ? faqs : []).map(faq => {
          if (faq.category.id === activeTab) {
            return (
              <div
                key={faq.faqId}
                className="TagCloudItemGroup__cardResult__card"
                onClick={() => handleOnClick(faq)}
                role="button"
                tabIndex={0}
                onKeyDown={e => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    handleOnClick(faq)
                  }
                }}
              >
                <div className="TagCloudItemGroup__cardResult__cardContent">
                  <div className="TagCloudItemGroup__cardResult__cardContent__title">
                    <p>{faq.category.text}</p>
                  </div>
                  <div className="TagCloudItemGroup__cardResult__cardContent__faqContent">
                    <h4>{faq.question}</h4>
                  </div>
                </div>
              </div>
            )
          }
        })}
      </div>
    )
  }
  return (
    <div className="TagCloudItemGroup__cardResult">
      {(Array.isArray(faqs) ? faqs : []).map(faq => (
        <div
          key={faq.faqId}
          className="TagCloudItemGroup__cardResult__card"
          onClick={() => handleOnClick(faq)}
          role="button"
          tabIndex={0}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              handleOnClick(faq)
            }
          }}
        >
          <div className="TagCloudItemGroup__cardResult__cardContent">
            <div className="TagCloudItemGroup__cardResult__cardContent__title">
              <p>{faq.category.text}</p>
            </div>
            <div className="TagCloudItemGroup__cardResult__cardContent__faqContent">
              <h4>{faq.question}</h4>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default TagCloudItem
